export default __webpack_public_path__ + "static/media/miguel-lopes-29.507b4e3c.jpg";